import { render, staticRenderFns } from "./SelectOrder.vue?vue&type=template&id=fd483d7a&scoped=true&"
import script from "./SelectOrder.vue?vue&type=script&lang=js&"
export * from "./SelectOrder.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrder.vue?vue&type=style&index=0&id=fd483d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd483d7a",
  null
  
)

export default component.exports